import { Component, Input, OnInit } from '@angular/core';
import { InputType } from '../../enums/input-type.enum';

@Component({
  selector: 'app-text-view-control',
  templateUrl: './text-view-control.component.html',
  styleUrl: './text-view-control.component.scss'
})
export class TextViewControlComponent implements OnInit {
  @Input() label: string = '';
  @Input() showLabel = true;
  @Input() isBold = true;
  @Input() isPrimary = false;

  @Input() type: InputType = InputType.Text;
  @Input() value?: string | number | string[] | number[] = '';

  setValue(val: string | number | string[] | number[]) {
    if (Array.isArray(val)) {
      return val.join(', ');
    }
    return val;
  }

  constructor() {}

  ngOnInit(): void {}
}
